import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Title from "../../../components/Title";
import { CreateTwoTone, DeleteOutlineRounded } from "@material-ui/icons";
import TDRService from "../../../services/TDRService";
import { DataGrid } from '@material-ui/data-grid';
import ConfirmationDialog from "../../tools/ConfirmationDialog";
import Message from "../../tools/Message";
import CheckIcon from "@material-ui/icons/Send";
import CloseIcon from '@material-ui/icons/Close';
import TextField from "@material-ui/core/TextField";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from "@material-ui/core/Grid";
import { Link } from "react-router-dom";
import LoadingSimpleBackdrop from "../../tools/LoadingSimpleBackdrop";
import { useNavigate } from 'react-router-dom';
import ValidationService from "../../../services/ValidationService";
import PlanningMissionService from "../../../services/PlanningMissionService";
import Autocomplete from "@material-ui/lab/Autocomplete";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import LoadingButton from '@mui/lab/LoadingButton';


const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
  root: {
    padding: theme.spacing(0.5, 0.5, 0),
    justifyContent: 'space-between',
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
  }
}));

export default function DemandeTable(props) {

  const navigate = useNavigate();
  const [activity, setActivity] = useState([]);
  const [rows, setRows] = useState([]);
  const [id_to_delete, setId_to_delete] = useState(0);
  const [id_to_annuler, setId_to_annuler] = useState(0);
  const [urg, setUgr] = useState(0);
  const [etat, setEtat] = useState({ open: false, message: "message", accept: false });
  const [isstatus, setIsstatus] = useState(0);
  const [ligne, setLigne] = useState([]);
  const [detailvalidation,setDetailvalidation]=useState([]);
  const [lien, setLien] = useState();
  const [activity_id,setActivity_id]=useState({});
  const [statut_val,setStatut_val]=useState({ label: 'Nouveau', id: 'Nouveau' });
  const [message, setMessage] = React.useState({
    open: false,
    color: 'green',
    messageInfo: '',
  });
  const [opens, setOpens] = React.useState(false);
  const [ouvert, setOuvert] = React.useState(false);
  const [issee,setSee]=useState(false);

  //Samuela: paramètrage pour le loader
  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = React.useState(false);

  const handleClickOpen = (id) => {
    setOpens(true);
    TDRService.Alls(id).then((result) => {
      if (result && result.data) {
        setLigne(result.data);
      }
    });

  };
  const statut = [
    { label: 'Aucun', id: 'Aucun' },
    { label: 'Nouveau', id: 'Nouveau' },
    { label: 'En attente de validation', id: 'En attente de validation' },
    { label: 'Validé', id: 'Validé' },
    { label: 'Refusé', id: 'Refusé' },
  ];

  const { open, color, messageInfo } = message;
  const [loading,setLoading]=useState(false);
  const [confirmationDialog, setConfirmationDialog] = React.useState({
    openDialog: false,
    messageDialog: 'Voulez vous vraiment supprimer  ?',
  });
  const { openDialog, messageDialog } = confirmationDialog;

  const handleDelete = (id) => (ev) => {
    setId_to_delete(id);
    setOuvert(true);
  };


  const handleClickClose = () => {
    setOpens(false);
    setOuvert(false);
  };


  const handleAnnuler = (id) => (ev) => {
    setId_to_annuler(id);
    setConfirmationDialog({ ...confirmationDialog, openDialog: true });
  };

  function closeDialog() {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false });
  }

  function confirmDialog() {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false });
    ValidationService.delete(id_to_annuler).then((result) => {
      TDRService.updateTDR(id_to_annuler).then((result) => {
        TDRService.All(statut_val.label,activity_id.name).then((result) => {
          if (result && result.data) {
            setRows(result.data.map((row) => ({ ...row, id: row.mission_request_id })));
          }
        });

        if (result.status) {
          setMessage({ ...message, open: true, color: 'green', messageInfo: result.message });
        } else {
          setMessage({ ...message, open: true, color: 'red', messageInfo: result.message });
        }
      }).catch((err) => {
        setMessage({ ...message, open: true, color: 'red', messageInfo: 'erreur' });
      });
    });
  }

  function cancelDialog() {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false });
  }

  function giveListe(id) {
    const ids = id[0];
    TDRService.Alls(ids).then((result) => {
      if (result && result.data) {
        setLigne(result.data);
      }
    });
    TDRService.pdf(ids).then((result) => {
      if (result && result.data) {
        setLien(result.data);
      }
    });
  }
  const classes = useStyles();
  useEffect(() => {
    setOpenLoadingSimpleBackdrop(true);
    TDRService.All(statut_val.label,activity_id.name).then((result) => {
      if (result && result.data) {
        setRows(result.data.map((row) => ({ ...row, id: row.mission_request_id, file_request_id: row.file_request_id })));
        setOpenLoadingSimpleBackdrop(false);
      } else {
        setOpenLoadingSimpleBackdrop(false);
      }
    });
    if (lien) {
      TDRService.saveFile(lien, id_to_delete)
        .then((result) => {
        })
        .catch((err) => {
          alert("error");
        });
    }

    PlanningMissionService.getActivity().then((result) => {
      if (result && result.data) {
        setActivity(result.data);
      }
    });
  }, [setRows,activity_id,statut_val]);
  useEffect(() => {

    PlanningMissionService.getActivity().then((result) => {
      if (result && result.data) {
        setActivity(result.data);
      }
    });
  }, []);


  const handleSee = (id, file_request_id) => (ev) => {
    setSee(true);
    setOpens(true);
    TDRService.Alls(id).then((result) => {
      if (result && result.data) {
        setLigne(result.data);
      }
    });

    TDRService.listevalidation(file_request_id).then((result) => {
      if (result && result.data) {
        setDetailvalidation(result.data);
      }
    });
  }


  const handleGenerateFile = (id, file_request_id) => (ev) => {
    setOpenLoadingSimpleBackdrop(true);
    handleClickOpen(id);
    setSee(false);
    setId_to_delete(id);
    setIsstatus(file_request_id);
    TDRService.pdf(id).then((result) => {
      if (result && result.data) {
        setLien(result.data);
        navigate("/mission/demande");
        setOpenLoadingSimpleBackdrop(false);
      }
    });
    setOpenLoadingSimpleBackdrop(false);
  }

  const handleEdit = (id) => (ev) => {
    navigate("/mission/demande/add/" + id);
  };

  function getFullName(params) {
    return `${params.getValue(params.id, 'first_name') || ''} ${params.getValue(params.id, 'last_name') || ''
      }`;
  }


  const handleClose = () => {
    setLoading(true);
    ValidationService.saveValidation(id_to_delete)
      .then((result) => {
        var responseErrorMessage = result.message;
        setLoading(false);
        TDRService.All(statut_val.label,activity_id.name).then((result) => {
          if (result && result.data) {
            setRows(result.data.map((row) => ({ ...row, id: row.mission_request_id })));
            setOpenLoadingSimpleBackdrop(false);
          } else {
            setOpenLoadingSimpleBackdrop(false);
          }
        });

        if (result.status) {
          setMessage({ ...message, open: true, color: 'green', messageInfo: responseErrorMessage });
        } else {
          setMessage({ ...message, open: true, color: 'red', messageInfo: responseErrorMessage });
        }
      }).catch((err) => {
        setMessage({ ...message, open: true, color: 'red', messageInfo: 'erreur' });
      });
    setOpens(false);

  };

  function formatDate(dateString) {
    const date = new Date(dateString);
  
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const year = date.getFullYear();
  
    return `${day}/${month}/${year}`;
  }

  const columns = [
    {
      field: 's',
      headerName: 'Détails',
      disableClickEventBulbing: true,
      renderCell: (params) => {
        setUgr(params.row.file_request_id);
        return (
          <div>
            <Button onClick={handleSee(params.id, params.row.file_request_id)} title='Voir les détails de la demande' >
                <RemoveRedEyeIcon style={{ color: "#005b8f" }} />
           </Button>
          </div>
        );
      },
      width: 125,
    },
    {
      field: 'composant',
      headerName: 'Composant',
      width: 200,
    },
    {
      field: 'type_mission_request',
      headerName: 'Type de demande',
      width: 250,
    },
    {
      field: 'reason',
      headerName: 'Raison',
      width: 300,
    },
    // {
    //   field: 'name_demandeur',
    //   headerName: 'Demandeur',
    //   width: 250,
    // },
    {
      field: 'number_day',
      headerName: 'Nombre(s) de jour(s)',
      width: 250,
    },
    {
      field: 'date', 
      headerName: 'Date désirée',
      width: 250,
      valueFormatter: ({ value }) => formatDate(value),
    },
    {
      field: 'status',
      headerName: 'Statut',
      width: 200,
    },
    {
      field: 'action',
      headerName: 'Action',
      disableClickEventBulbing: true,
      renderCell: (params) => {
        setUgr(params.row.file_request_id);
        return (
          <div>
            {params.row.status === "Nouveau" &&
              <Button onClick={handleGenerateFile(params.id, params.row.file_request_id)} title='Envoyer pour validation' >
                <CheckIcon style={{ color: "green" }} />
              </Button>
            }
            {params.row.file_request_id !== null && params.row.status==='en attente de validation' &&
              <Button onClick={handleAnnuler(params.id)} title="Annulation de l'attente de validation">
                <CloseIcon style={{ color: "red" }} />
              </Button>

            }
            {params.row.status === "Nouveau" &&
              <Button onClick={handleEdit(params.id)}><CreateTwoTone style={{ color: "black" }} />
              </Button>
            }
            {params.row.status === "Nouveau" &&
              <Button onClick={handleDelete(params.id)}>
                <DeleteOutlineRounded style={{ color: "red" }} />
              </Button>
            }

          </div>
        );
      },
      width: 200,
    },
  ];
  function handleCloseMessage() {
    setMessage({ ...message, open: false });

  }


  const handleToClose = () => {
    setOuvert(false);
    TDRService.delete(id_to_delete).then((result) => {
      TDRService.All(statut_val.label,activity_id.name).then((result) => {
        if (result && result.data) {
          setRows(result.data.map((row) => ({ ...row, id: row.mission_request_id })));
          setOuvert(false);
        } else {
          setOuvert(false);

        }
      });
      if (result.status) {
        setMessage({ ...message, open: true, color: 'green', messageInfo: result.message });
      } else {
        setMessage({ ...message, open: true, color: 'red', messageInfo: result.message });
      }
    }).catch((err) => {
      setMessage({ ...message, open: true, color: 'red', messageInfo: 'erreur' });
    });
  };

  function handleChangeTypeActivity(event, value) {
    console.log(value);
    setActivity_id(value);
  }

  function handleChangeTypeStatut(event, value) {
    console.log(value);
    setStatut_val(value);
  }

  return (
    <React.Fragment>
      <ConfirmationDialog openDialog={openDialog} messageDialog={messageDialog} closeDialog={closeDialog} confirmDialog={confirmDialog} cancelDialog={cancelDialog} />
      <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
      <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
      <Grid item xs={12}>
              <Grid container spacing={3}>
                {/* <Grid item xs={3}>
                  <Autocomplete
                    id="tags-outlined"
                    options={activity}
                    getOptionLabel={(option) => option.name}
                    filterSelectedOptions
                    onChange={handleChangeTypeActivity}
                    //value={activity_id}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        id="outlined-basic"
                        size="small"
                        label="Composante"
                        variant="outlined"
                        placeholder="Composante"
                      />
                    )}
                  />
                </Grid> */}
                <Grid item xs={3}>
                  <Autocomplete
                    id="tags-outlined"
                    options={statut}
                    getOptionLabel={(option) => option.label}
                    onChange={handleChangeTypeStatut}
                    value={statut_val}
                    filterSelectedOptions
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        id="outlined-basic"
                        size="small"
                        label="Statut"
                        variant="outlined"
                        placeholder="Statut"
                      />
                    )}
                  />
                </Grid>
           </Grid>
        </Grid>
        <br/>
        <br/>
      <Title>Liste de mes demandes d'appui</Title>
      <div style={{ height: 400, width: '100%' }} className={classes.root}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5]}
          disableSelectionOnClick
        />
      </div>
                        {/* <Grid item xs={5}>
                    <label className={classes.label}>Voir pdf:</label>
                  </Grid>
                  <Grid item xs={7}>
                    <label className={classes.label1}><Link to={"/PdfRender/" + lien}>.pdf</Link></label>
                  </Grid> */}
      <div>
        <Dialog
          open={opens}
          // onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="form-dialog-title" style={{ color: 'white', }}>
            {"Information Demande d'appui"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description" style={{ width: 600, }}>
              {ligne.map((row) => (
                <Grid container spacing={2} >
                  <Grid item xs={5}>
                    <label className={classes.label}>Type de demande:</label>
                  </Grid>
                  <Grid item xs={7}>
                    <label className={classes.label1}>{row.type_mission_request}</label>
                  </Grid>
                  <Grid item xs={5}>
                    <label className={classes.label}>Raison :</label>
                  </Grid>
                  <Grid item xs={7}>
                    <label className={classes.label1}>{row.reason}</label>
                  </Grid>
                  <Grid item xs={5}>
                    <label className={classes.label}>Composant:</label>
                  </Grid>
                  <Grid item xs={7}>
                    <label className={classes.label1}>{row.name}</label>
                  </Grid>

                  {detailvalidation.length>0 &&
                      <Grid item xs={12}> 
                               <TableContainer style={{ maxWidth: '100%', overflowX: 'auto' }}>
                                  <Table  aria-label="a dense table">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell>Nom du validateur</TableCell>
                                        <TableCell align="right">Direction</TableCell>
                                        <TableCell align="right">Status</TableCell>
                                        <TableCell align="right">Suite de votre demande</TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {detailvalidation.map((row) => (
                                        <TableRow
                                          key={row.name}
                                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                          <TableCell component="th" scope="row">
                                            {row.user_name}
                                          </TableCell>
                                          <TableCell align="right">{row.direction_code}</TableCell>
                                          <TableCell align="right">{row.validation_status}</TableCell>
                                          <TableCell align="right">{row.request_suite}</TableCell>
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                       </Grid>
                  }
                </Grid>
              ))}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClickClose} variant="contained" color="secondary">
              Annuler
            </Button>
            {!issee&&
               <LoadingButton
                  onClick={handleClose}
                  loading={loading}
                  loadingPosition="end"
                  variant="contained"
              >
                  Envoyer
              </LoadingButton>
            }
          </DialogActions>
        </Dialog>


        <div stlye={{}}>
          <Dialog open={ouvert} 
          // onClose={handleToClose}
          >
            <DialogTitle id="form-dialog-title" style={{ color: 'white', }}>
              {"Information Demande d'appui"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                voulez-vous vraiment supprimer ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={handleClickClose} variant="contained" color="secondary">
              Annuler
            </Button>
          
              <Button onClick={handleToClose}
              variant="contained" color="primary">
              valider
              </Button>
            
            </DialogActions>
          </Dialog>
        </div>
      </div>
    </React.Fragment>
  );
}
